// Account/AdminUsersList.tsx

import React, { useEffect } from "react";
import { Box, Text, HStack, Button } from "native-base";
import { FlashList } from "@shopify/flash-list";
import AdminUserItem from "./AdminUserItem";
import { DeanteUser } from "./interfaces";


interface AdminUsersListProps {
  users: DeanteUser[];
  loading: boolean;
  error: string | null;
  onReload: () => void;
  onEditUser: (user: DeanteUser) => void;
  onDeleteUser: (user: DeanteUser) => void;
}

const AdminUsersList: React.FC<AdminUsersListProps> = ({
  users,
  loading,
  error,
  onReload,
  onEditUser,
  onDeleteUser,
}) => {
    useEffect(() => {
        onReload()
    },[])
  return (
    <Box mt={6}>
      <HStack justifyContent="space-between" alignItems="center" mb={2}>
        <Text fontSize="md" fontWeight="semibold">
          Список пользователей
        </Text>

        <Button
          size="sm"
          variant="outline"
          onPress={onReload}
          isLoading={loading}
        >
          Обновить
        </Button>
      </HStack>

      {error && (
        <Text color="red.500" fontSize="xs" mb={2}>
          {error}
        </Text>
      )}

      <Box maxH={320} w="100%">
        <FlashList
          data={users}
          estimatedItemSize={100}
          keyExtractor={(item) => item.login}
          renderItem={({ item }) => (
            <AdminUserItem
              user={item}
              onEditUser={onEditUser}
              onDeleteUser={onDeleteUser}
            />
          )}
        />
      </Box>
    </Box>
  );
};

export default AdminUsersList;
